const defualtStorage = window.localStorage;
export const AppStorage = {
  getItem<T>(key: string, defualtValue: any = null): T {
    const data = defualtStorage.getItem(key);
    if (data) {
      return JSON.parse(data);
    }
    return defualtValue;
  },
  setItem(key: string, value: any) {
    defualtStorage.setItem(key, JSON.stringify(value));
  },
  removeItem(key: string) {
    defualtStorage.removeItem(key);
  },
  clear() {
    defualtStorage.clear();
  }
};
